import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Config from "../Config.json";
import { useNavigate, useParams } from "react-router-dom";

import { useTranslation } from "react-i18next";

const About = () => {
  const TITLE = Config.SITE_TITLE + " | Rólam";
  const DESC = "János Eszter okleveles gyógypedikűrös bemutatkozása.";
  const CANONICAL = Config.SITE_DOMAIN + "/about";

  return (
    <main className="main-content">
      <Helmet>
        <title>{TITLE}</title>
        <link rel="canonical" href={CANONICAL} />
        <meta name="description" content={DESC} />
        <meta name="theme-color" content={Config.THEME_COLOR} />
      </Helmet>

      <div className="about-container">
        <div className="about-image">
          <img
            src="/images/1749217349815.jpg" // Cseréld a saját képed útvonalára
            alt="János Eszter"
            className="animated-img"
          />
        </div>
        <div className="about-text">
          <h2>János Eszter</h2>
          <p>
            János Eszter vagyok, okleveles gyógypedikűrös és masszázsterapeuta,
            több szakterületen szerzett képesítéssel. Munkám során kiemelten
            fontos számomra a vendégek egészsége, jó közérzete és elégedettsége.
          </p>
          <p>
            A szakmában töltött évek alatt gyógypedikűr, pedikűr, tradicionális
            thai jóga masszázs, manager masszázs, valamint svédmasszázs terén
            szereztem végzettséget, melyekről hivatalos oklevelekkel
            rendelkezem. Minden kezelés előtt és után állapotfelmérést végzek,
            így a szolgáltatásokat személyre szabottan tudom alkalmazni az
            aktuális állapotnak megfelelően.
          </p>
          <p>
            <strong>Küldetésem:</strong> Elsődleges célom a fájdalomcsillapító
            kezelések alkalmazása, ugyanakkor természetesen elérhetők frissítő
            és lazító masszázsok is. Szolgáltatásaim segítenek a közérzet
            javításában, testi-lelki felfrissülést nyújtanak, miközben szakmai
            tanácsadással is támogatom vendégeimet.
          </p>
          <h3>Szolgáltatások:</h3>
          <ul>
            <li>Gyógypedikűr</li>
            <li>Pedikűr</li>
            <li>Tradicionális thai jóga masszázs</li>
            <li>Manager masszázs</li>
            <li>Svédmasszázs</li>
            <li>Állapotfelmérés</li>
            <li>Tanácsadás</li>
          </ul>
        </div>
      </div>
    </main>
  );
};

export default About;
